module.exports = __webpack_public_path__ + "static/media/PierSans-Italic.789e25e5.otf";